import React from "react";
import ReactDOM from "react-dom";
import Popup from "../../popup/Popup";
import './previewImgCellRenderer.css';
//This class component renders the button on the AG-grid
class PreviewImgCellRenderer extends React.Component{
    constructor(props){
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }
   
    btnClickedHandler() {
        this.popup();
    }
    
    popup(){
        const node = document.createElement("div");
        document.body.appendChild(node);
        ReactDOM.render(
            <Popup 
                manifestID={this.props.value}
                drive={this.props.data.Drive}
                path={this.props.data.Path}
                DPath={this.props.data.DPath}
                fileName={this.props.data.FileName}
                docAiManifestImageId={this.props.data.DocAiManifestImageId}
            />,
            node
        );
        //The block of code below may be needed in the future
        // const clear = () => {
        //         ReactDOM.unmountComponentAtNode(node);
        //         node.remove();
        // }
    }
       render() {
         return (
           <button className="img-preview-btn" onClick={this.btnClickedHandler}>Image Preview</button>
         )
       }
}

export default PreviewImgCellRenderer;